import React, { useState, useEffect } from 'react';
import { albumsAPI } from '../services/api';

const Albums = () => {
  const [albums, setAlbums] = useState([]);
  const [lang, setLang] = useState('en');
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    loadAlbums();
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const checkMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const loadAlbums = async () => {
    try {
      const response = await albumsAPI.getAll();
      setAlbums(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error loading albums:', error);
      setLoading(false);
    }
  };

  if (loading) return <div style={styles.loading}>Cargando...</div>;

  return (
    <section style={isMobile ? {...styles.section, ...styles.sectionMobile} : styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={isMobile ? {...styles.title, ...styles.titleMobile} : styles.title}>ALBUMS</h2>
          <button 
            onClick={() => setLang(lang === 'en' ? 'es' : 'en')}
            style={styles.langButton}
          >
            {lang === 'en' ? 'ES' : 'EN'}
          </button>
        </div>
        
        <div style={isMobile ? {...styles.grid, ...styles.gridMobile} : styles.grid}>
          {albums.map(album => (
            <div key={album.id} style={styles.card}>
              <div style={styles.imageContainer}>
                {album.imageUrl ? (
                  <img 
                    src={album.imageUrl}
                    alt={album.title} 
                    style={styles.image}
                  />
                ) : (
                  <div style={styles.placeholder}>♪</div>
                )}
              </div>

              <div style={isMobile ? {...styles.cardContent, ...styles.cardContentMobile} : styles.cardContent}>
                <h3 style={isMobile ? {...styles.cardTitle, ...styles.cardTitleMobile} : styles.cardTitle}>
                  {lang === 'en' ? album.titleEn : album.titleEs}
                </h3>
                <p style={styles.cardDate}>
                  {new Date(album.releaseDate + 'T12:00:00').toLocaleDateString(
                    lang === 'en' ? 'en-US' : 'es-ES',
                    { year: 'numeric', month: 'long', day: 'numeric' }
                  )}
                </p>
                <p style={styles.cardText}>
                  {lang === 'en' ? 'All songs composed by' : 'Todos los temas compuestos por'} {album.composer}
                </p>
                <p style={styles.cardText}>
                  {lang === 'en' ? 'All rights reserved' : 'Derechos reservados'}
                </p>
                <p style={styles.cardTagline}>
                  {lang === 'en' ? album.taglineEn : album.taglineEs}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    minHeight: '100vh',
    background: '#000',
    padding: '100px 2rem 4rem',
    fontFamily: 'Roboto, sans-serif',
  },
  sectionMobile: {
    padding: '80px 1rem 2rem',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    fontFamily: 'Roboto, sans-serif',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '3rem',
    fontFamily: 'Roboto, sans-serif',
  },
  title: {
    fontSize: '3rem',
    color: '#fff',
    letterSpacing: '0.3rem',
    fontFamily: 'Roboto, sans-serif',
  },
  titleMobile: {
    fontSize: '2rem',
    letterSpacing: '0.15rem',
  },
  langButton: {
    padding: '0.5rem 1.5rem',
    background: '#222',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    borderRadius: '5px',
    transition: 'background 0.3s',
    fontFamily: 'Roboto, sans-serif',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
    fontFamily: 'Roboto, sans-serif',
  },
  gridMobile: {
    gridTemplateColumns: '1fr',
    gap: '1.5rem',
  },
  card: {
    background: '#111',
    borderRadius: '10px',
    overflow: 'hidden',
    transition: 'transform 0.3s',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Roboto, sans-serif',
  },
  imageContainer: {
    width: '100%',
    background: '#222',
    overflow: 'hidden',
    fontFamily: 'Roboto, sans-serif',
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
    fontFamily: 'Roboto, sans-serif',
  },
  placeholder: {
    fontSize: '4rem',
    color: '#444',
    padding: '4rem 0',
    textAlign: 'center',
    fontFamily: 'Roboto, sans-serif',
  },
  cardContent: {
    padding: '1.5rem',
    flex: 1,
    fontFamily: 'Roboto, sans-serif',
  },
  cardContentMobile: {
    padding: '1rem',
  },
  cardTitle: {
    fontSize: '1.5rem',
    color: '#fff',
    marginBottom: '0.5rem',
    fontFamily: 'Roboto, sans-serif',
  },
  cardTitleMobile: {
    fontSize: '1.2rem',
  },
  cardDate: {
    color: '#888',
    marginBottom: '0.5rem',
    fontFamily: 'Roboto, sans-serif',
  },
  cardText: {
    color: '#aaa',
    lineHeight: '1.6',
    marginBottom: '0.5rem',
    fontSize: '0.9rem',
    fontFamily: 'Roboto, sans-serif',
  },
  cardTagline: {
    color: '#fff',
    fontStyle: 'italic',
    marginTop: '1rem',
    fontFamily: 'Roboto, sans-serif',
  },
  loading: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '1.5rem',
    fontFamily: 'Roboto, sans-serif',
  },
};

export default Albums;
